import React from "react";

//配置项
let componentName = "liveStatistics";

const columns = [
  {
    title: "参训统计名称",
    name: "name",
    searchItem: {},
    tableItem: {},
  },
  {
    title: "统计方式",
    name: "bizType",
    tableItem: {},
    searchItem: {
      type: "select",
    },
    dict: [
      { code: 1, codeName: "单个方式" },
      { code: 2, codeName: "组合方式" }
    ],
  },
  {
    title: "统计状态",
    name: "status",
    tableItem: {},
    searchItem: {
      type: "select",
    },
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
  },
  {
    title: "创建时间",
    name: "createTime",
    tableItem: {},
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', "delete"],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/trainingStatistics/trainingStatisticsList/trainingStatisticsAdd"
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      rowOperateSort: ["update", "assessmentRulesManagement", "look", 'updateTrainingStatistics', 'synchronizeTrainingRecords'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/trainingStatistics/trainingStatisticsList/trainingStatisticsUpd",
            },
          },
        },
        {
          key: "assessmentRulesManagement",
          custom: true,
          params: { children: "考核规则管理" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/trainingStatistics/trainingStatisticsList/assessmentRulesList",
            },
          },
        },
        {
          key: "look",
          custom: true,
          params: { children: "查看参训统计" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/trainingStatistics/trainingStatisticsList/dataReport",
            },
          },
        },
        {
          key: "updateTrainingStatistics",
          custom: true,
          params: { children: "更新参训统计数据" },
          customOnClick: {
            key: "action",
            params: {
              apiKey:"updateTrainingStatistics"
            },
            formatParams: (rows, { id }, filters, callback) => ({ id })
          }
        },
        {
          key: "synchronizeTrainingRecords",
          custom: true,
          params: { children: '同步参训记录' },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "syncRecord"
            },
            formatParams: (rows, { id }, filters, callback) => ({ id })
          }
        },
      ],
      rowOperateProps: { width: 330 },
    },
  },
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { type: 2 },
    },
  },
  updateTrainingStatistics: {
    path: `${componentName}/updateTrainingStatistics`,
    payload: {
      key: `${componentName}@updateTrainingStatistics`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {},
    },
  },
  syncRecord: {
    path: 'statisticsRule/syncRecord',
    payload: {
      key: 'statisticsRule@syncRecord',
      apiParams: {}
    }
  }
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams:true,
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
